import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import HeaderLabelTitle from "../../../unit/HeaderLabelTitle";

const PublicRecordsList = ({ publicRecord, public_record_type }: any) => {
  return <></>;
};

const PublicRecords = (sourcedata: any) => {
  const publicRecord = sourcedata.publicRecord;
  const public_record_type = sourcedata.public_record_type;
  const publicRecordSize = publicRecord ? publicRecord.length : 0;

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <HeaderLabelTitle
          title={
            `Public Records (total <span style="color: #1976d2;">` +
            publicRecordSize +
            `</span> record)`
          }
          suffix=""
        />
      </AccordionSummary>
      <AccordionDetails>
        <PublicRecordsList
          publicRecord={publicRecord}
          public_record_type={public_record_type}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default PublicRecords;
